import { Injectable } from '@angular/core';
import { environment } from '@ca/environment/environment';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { take } from 'rxjs/operators';
import { authConfig } from './auth-config';
import { UserNotificationService } from './user-notification.service';
import { UserService } from './user.service';
import { WindowRef } from './window.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    get accessToken(): string | null {
        return this.oauthService.getAccessToken() || localStorage.getItem('access_token');
    }

    constructor(
        private userNotificationService: UserNotificationService,
        private oauthService: OAuthService,
        private userService: UserService,
        private translateService: TranslateService,
        private windowRef: WindowRef,
    ) {}

    handleNonAuthorizedRoutesOrRequests(): void {
        this.userService.logout(true);

        // We need to use get() here as the translations might not be initialized yet
        this.translateService
            .get('ERROR_MESSAGES.NOT_AUTHORIZED_ERROR')
            .pipe(take(1))
            .subscribe((translation: string) => {
                this.userNotificationService.showInfo(translation);
            });
        if (!this.windowRef.isLocalhost) {
            this.windowRef.nativeWindow.location.href = environment.landingPageUrl;
        }
    }

    hasValidAccessToken(): boolean {
        return this.oauthService.hasValidAccessToken();
    }

    login(): void {
        this.oauthService.initImplicitFlow();
    }

    async configureAuth(): Promise<boolean> {
        this.oauthService.configure(authConfig);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.setStorage(localStorage);
        this.oauthService.setupAutomaticSilentRefresh({}, 'access_token');
        return this.oauthService.loadDiscoveryDocumentAndTryLogin();
    }
}
